<template>
    <div>
        <div class="tittle">
            <div class="titletop flex">
                <div class="logo fl">
                    <img
                        src="../../assets/images/logoAll.png"
                        alt=""
                    />
                </div>
            </div>
        </div>
        <div class="loginBack" :style="{ height: parkHeight }">
            <div class="login_box">
                <h3>账户密码登录</h3>
                <!-- 账户密码登录 -->
                <div>
                    <div class="login_input">
                        <input
                            type="text"
                            placeholder="用户名/账号/手机号"
                            v-model="username"
                        />
                        <el-input
                            placeholder="请输入登录密码"
                            show-password
                            v-model="password"
                        >
                        </el-input>
                    </div>
                </div>
                <div class="login_button">
                    <button @click="getLogin()">登 录</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        getUserAndPassLogin,
        getNewcurrent,
        getMenuList
    } from "../../utils/interface";

    export default {
        name: "login",
        data() {
            return {
                parkHeight: '',
                username: "",
                password: "",
                loginIndex: "0",
            };
        },
        computed: {},
        created() {
            this.parkHeight = document.documentElement.clientHeight + "px";
        },
        methods: {
            getLogin() {
                let params = {
                    username: this.username,
                    password: this.password,
                };
                // 手机用户名登录
                if (this.username == "" || this.password == "") {
                    if (this.username == "") {
                        this.$alert("请填写用户名", "提示", {
                            confirmButtonText: "确定",
                        });
                    } else if (this.password == "") {
                        this.$alert("请输入密码", "提示", {
                            confirmButtonText: "确定",
                        });
                    }
                } else {
                    getUserAndPassLogin(params)
                        .then((res) => {
                            // this.$store.commit('userMessagesVuex', res.data)
                            if (res.access_token) {
                                this.$cookies.remove("api_access_token");
                                this.$cookies.set(
                                    "api_access_token",
                                    res.access_token
                                );
                                this.$cookies.set("api_token_new", res.access_token);
                                 getNewcurrent().then((resmess) => {
                                    if(resmess.authorities.indexOf('designerCenterService') > -1) {
                                        this.$cookies.set("authoritiesMess",'designerCenterService');
                                        getMenuList().then(res=>{
                                            if(res.length > 0){
                                                window.sessionStorage.setItem('menuList', JSON.stringify(res || []))
                                                this.resetSetItem('menuActiveId',res[0].uuid)
                                                // 成功后直接跳转
                                                this.$router.push("/home");
                                            }
                                        })
                                    } else {
                                        this.$alert('权限不足，请联系管理员!', "提示", {
                                            confirmButtonText: "确定",
                                        })
                                        this.$router.push("/");
                                    }

                                })
                                .catch((err) => {
                                    console.log(err);
                                });
                                // this.$cookies.set(
                                //     "api_token_new",
                                //     res.access_token
                                // );
                                // // 成功后直接跳转
                                // this.$router.push('/home')
                                // this.resetSetItem('menuActiveId','0')
                            } else {
                                this.$alert(res.error, "提示", {
                                    confirmButtonText: "确定",
                                });
                            }
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                }
            }
        },
    };
</script>

<style scoped lang="less">
    .blue {
        color: #1181ff;
    }

    .red {
        color: #d60000;
    }

    .loginBack {
        background: url("../../assets/images/loginBanner.png") no-repeat;
        background-size: 100% 100%;
        position: relative;

        .login_box {
            background: #fff;
            border-radius: 10px;
            width: 476px;
            position: absolute;
            right: 16%;
            top: 50%;
            padding: 30px;
            margin-top: -180px;

            h3 {
                margin: 0;
                text-align: center;
                font-size: 18px;
                font-weight: normal;
            }

            .login_input {
                width: 100%;
                margin-top: 35px;

                input {
                    border: 1px solid #f9f9f9;
                    border-radius: 10px;
                    background: #fff;
                    width: 100%;
                    height: 60px;
                    padding-left: 20px;
                    font-size: 16px;
                    color: #777;
                    box-sizing: border-box;
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    outline: none;
                }

                input:nth-child(1) {
                    margin-bottom: 20px;
                }

                input::-webkit-input-placeholder {
                    color: #b3b3b3;
                }

                /deep/ .el-input__inner {
                    border: 1px solid #f9f9f9;
                    border-radius: 10px;
                    background: #fff;
                    width: 100%;
                    height: 60px;
                    padding-left: 20px;
                    font-size: 16px;
                    color: #777;
                    box-sizing: border-box;
                    -webkit-box-sizing: border-box;
                    -moz-box-sizing: border-box;
                    outline: none;
                }

                /deep/ .el-input__inner::-webkit-input-placeholder {
                    color: #b3b3b3;
                }
            }

            .login_button {
                width: 100%;
                margin: 24px 0 20px;

                button {
                    border: none;
                    background: #1181ff;
                    width: 100%;
                    height: 50px;
                    color: #fff;
                    font-weight: bold;
                    font-size: 18px;
                    border-radius: 10px;
                }
            }
        }
    }

    .tittle {
        position: fixed;
        background: #fff;
        box-shadow: 0 -1px 0 #f0f0f0 inset;
        width: 100%;
        height: 80px;
        z-index: 9999;

        .logo {
            // margin: 19px 42px 0 38px;
            align-items: center;
            display: flex;
            // flex: 1;
            img {
                height: 50px;
                margin: 8px 0 0 0;
                padding: 0;
            }
        }

        .titletop {
            width: 1200px;
            align-items: center;
            margin: 0 auto;
        }
    }

    .login {
        justify-content: center;
        align-items: center;
        // flex: 1;
        .lh90 {
            cursor: pointer;
            font-size: 15px;
        }

        .lh90:nth-last-child(1) {
            margin-left: 60px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue